import { canonicalCategorySlug } from '../lib/seo/category-hubs.js';

// Búsquedas del barrido sin página propia en market (se sumaron el 29/9 y el 5/10/2026): sus negocios viven en la
// página de su rubro. Sin esto, el chip de la tarjeta y la ficha enlazaban a /masajista, /spa… (200 +
// noindex). Las búsquedas con página (/peluqueria, /bar-de-cejas…) siguen con su slug.
const KEYWORD_CATEGORY = {
  Masajista: 'masajes',
  Spa: 'masajes',
  'Drenaje linfático': 'masajes',
  Esteticista: 'tratamientos-faciales',
  Dermatólogo: 'dermatologia',
  'Cirujano plástico': 'medicina-estetica',
  // Búsquedas del 5/10/2026.
  Estilista: 'peluqueria',
  Estética: 'tratamientos-faciales',
  Solarium: 'tratamientos-corporales',
  'Medicina estética': 'medicina-estetica'
};

const slugify = (name) =>
  name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');

// Las búsquedas que son un rubro duplicado (Manicuría → /unas) enlazan al que queda.
export const directoryCategorySlug = (keyword) =>
  keyword ? KEYWORD_CATEGORY[keyword] || canonicalCategorySlug(slugify(keyword)) : '';
